import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorB4ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorB4ByHealthTeamData {
	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalCitizens: number = 0;
	totalCitizensFinished: number = 0;
	totalCitizensFinishedLinked: number = 0;
}

export async function getResumeIndicatorB4ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorB4ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorB4ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b4/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorB4ByHealthTeamData>();
}
